export default "/images/thanks-confirmation-step.de.jpg?0dd3358ac8202633818db17133159aa8";